import { post } from '../http';

export const inviteClub = ({ email, isMember = false }) =>
  post(`v2/SharedResources/InviteClub`, { email, IsMember: isMember });

export const contactClub = (email, name) => post(`v2/SharedResources/ContactClub`, { email, name });
